import styled from '@emotion/styled';
import { Td } from '@lightspeed/cirrus-table';

export const TdWithLineBreaks = styled(Td)`
  white-space: pre-line;
`;
